import api from './api';

/**
 * Create a new group buy pool (admin only)
 */
export const createAdminGroupBuyPool = async (poolData) => {
  try {
    const response = await api.post('/admin/group-buy/create-pool/', poolData, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to create pool');
  }
};

/**
 * Get all group buy pools with filtering and pagination
 */
export const getGroupBuyPools = async (params = {}) => {
  try {
    const response = await api.get('/admin/group-buy/pools/', {
      params,
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch pools');
  }
};

/**
 * Get detailed information about a specific pool
 */
export const getGroupBuyPoolDetail = async (poolId) => {
  try {
    const response = await api.get(`/admin/group-buy/pools/${poolId}/`, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch pool details');
  }
};

/**
 * Update pool status and settings
 */
export const updateGroupBuyPool = async (poolId, updateData) => {
  try {
    // Check if we have a file upload (image)
    const hasFile = updateData.image instanceof File;

    let requestData = updateData;
    let config = { requiresAuth: true };

    // If we have a file, use FormData
    if (hasFile) {
      const formData = new FormData();

      // Add all non-file data
      Object.keys(updateData).forEach(key => {
        if (key !== 'image') {
          if (updateData[key] !== null && updateData[key] !== undefined && updateData[key] !== '') {
            formData.append(key, updateData[key]);
          }
        }
      });

      // Add the image file
      if (updateData.image) {
        formData.append('image', updateData.image);
      }

      requestData = formData;

      // Update config for FormData
      config = {
        ...config,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
    }

    const response = await api.patch(`/admin/group-buy/pools/${poolId}/update/`, requestData, config);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to update pool');
  }
};

/**
 * Perform bulk actions on multiple pools
 */
export const bulkActionGroupBuyPools = async (poolIds, action, value = null) => {
  try {
    const response = await api.post('/admin/group-buy/pools/bulk-action/', {
      pool_ids: poolIds,
      action: action,
      value: value
    }, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to perform bulk action');
  }
};

/**
 * Remove a participant from a pool
 */
export const removePoolParticipant = async (poolId, participantId) => {
  try {
    const response = await api.delete(`/admin/group-buy/pools/${poolId}/participants/${participantId}/remove/`, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to remove participant');
  }
};

/**
 * Get analytics data for group buy
 */
export const getGroupBuyAnalytics = async (params = {}) => {
  try {
    const response = await api.get('/admin/group-buy/analytics/', {
      params,
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch analytics');
  }
};

/**
 * Get admin settings for group buy
 */
export const getGroupBuySettings = async () => {
  try {
    const response = await api.get('/admin/group-buy/settings/', {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch settings');
  }
};

/**
 * Update admin settings for group buy
 */
export const updateGroupBuySettings = async (settings) => {
  try {
    const response = await api.post('/admin/group-buy/settings/', settings, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to update settings');
  }
};
